<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Aplicativo - Motorista | {{ id }}
          </p>
          <div class="heading-elements">
            <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
          </div>
        </div>

        <div class="box-body">
					<div v-show="errorMessage != ''" class="alert alert-danger">{{ errorMessage }}</div>

          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="end_longitude">Aplicativo: <sup class="text-danger">*</sup>&nbsp;&nbsp;&nbsp;</label>
              <span v-if="registro.aplicativo">
                {{ registro.aplicativo.descricao }}
              </span>
              <select
                id="aplicativos_ativos"
                v-else
                v-model="registro.cd_aplicativo"
                style="width: auto"
                class="form-control"
                @change="handleChange(registro.cd_aplicativo)"
                v-bind:class="{ 'box-input-required': errors.cd_aplicativo }"
              >
                <option
                  v-for="item in appsAtivosDisponiveis"
                  v-bind:key="item.cd_aplicativo_categoria"
                  v-bind:value="item.cd_aplicativo"
                >{{ item.descricao }}</option>
              </select>
              <span v-show="errors.cd_aplicativo != null" class="help-inline">{{ errors.cd_aplicativo }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="end_longitude">Status Perfil: <sup class="text-danger">*</sup>&nbsp;&nbsp;&nbsp;</label>
              <span v-if="registro.aplicativo" class="label" v-bind:class="{
                  'label-danger': [1,4].includes(registro.idc_imgem_perfil),
                  'label-warning': registro.idc_imgem_perfil === 2,
                  'label-success': registro.idc_imgem_perfil === 3,
                  'label-default': ![1,2,3,4].includes(registro.idc_imgem_perfil)
                }">{{ registro.imgem_perfil_desc }}</span>
                <select 
                  id="status_perfil"
                  v-else
                  style="width: auto" 
                  class="form-control" 
                  v-model="registro.idc_status" 
                  v-bind:class="{ 'box-input-required': errors.idc_status }"
                >
                  <option value="1">Ativo</option>
                  <option value="2">Inativo</option>
                </select>
              <span v-show="errors.idc_status != null" class="help-inline">{{ errors.idc_status }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="cd_aplicativo_categoria">Categoria <sup class="text-danger">* </sup></label>
              <select id="cd_aplicativo_categoria" v-model="registro.cd_aplicativo_categoria" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.cd_aplicativo_categoria }">
                <option
                  v-for="item in categorias"
                  v-bind:key="item.cd_aplicativo_categoria"
                  v-bind:value="item.cd_aplicativo_categoria"
                >{{ item.descricao }}</option>
              </select>
              <span v-show="errors.cd_aplicativo_categoria != null" class="help-inline">{{ errors.cd_aplicativo_categoria }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="cd_aplicativo_segmento">Segmento</label>
              <select id="cd_aplicativo_segmento" v-model="registro.cd_aplicativo_segmento" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.cd_aplicativo_segmento }">
                <option
                  v-for="item in segmentos"
                  v-bind:key="item.cd_aplicativo_segmento"
                  v-bind:value="item.cd_aplicativo_segmento"
                >{{ item.descricao }}</option>
              </select>
              <span v-show="errors.cd_aplicativo_segmento != null" class="help-inline">{{ errors.cd_aplicativo_segmento }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="tempo_aplicativo">Tempo de App (em meses)<sup class="text-danger">* </sup></label>
              <input id="tempo_aplicativo" v-model="registro.tempo_aplicativo" v-mask="'######'" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.tempo_aplicativo }">
              <span v-show="errors.tempo_aplicativo != null" class="help-inline">{{ errors.tempo_aplicativo }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="viagens_realizadas">Viagens Realizadas <sup class="text-danger">* </sup></label>
              <input id="viagens_realizadas" v-model="registro.viagens_realizadas" v-mask="'#######'" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.viagens_realizadas }">
              <span v-show="errors.viagens_realizadas != null" class="help-inline">{{ errors.viagens_realizadas }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="nota_motorista">Avaliação <sup class="text-danger">* </sup></label>
              <input id="nota_motorista" v-model="registro.nota_motorista" v-mask="'#.##'" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.nota_motorista }">
              <span v-show="errors.nota_motorista != null" class="help-inline">{{ errors.nota_motorista }}</span>
            </div>
          </div>
        </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" class="btn btn-warning" @click="voltar()">Cancelar</button>
            <button type="button" class="btn btn-success" @click="gravar()">Gravar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MotoristaAplicativoActions from '../../actions/MotoristaAplicativoActions'
import AplicativoCategoriaActions from '../../actions/AplicativoCategoriaActions'
import AplicativoSegmentoActions from '../../actions/AplicativoSegmentoActions'
import AplicativoActions from '../../actions/AplicativoActions'

export default {
  name: 'editar',
  props: ['id', 'cd_aplicativo'],
  data () {
    return {
      errorMessage: '',
      errors: {},
      hasError: false,
      showModalLoader: 0,
      registro: {
        aplicativo: null,
        aplicativoCategoria: null,
        aplicativoSegmento: null,
        cd_motorista: this.id,
        cd_aplicativo: '',
        tempo_aplicativo: '',
        nota_motorista: '',
        viagens_realizadas: '',
        idc_status: '',
        idc_imgem_perfil: ''
      },
      categorias: [],
      segmentos: [],
      appsAtivos: [],
      appsAtivosDisponiveis: []
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Editar'

    if (this.id && this.cd_aplicativo) {
      this.listarCategorias(this.cd_aplicativo)
      this.listarSegmentos(this.cd_aplicativo)

      this.showModalLoader++

      MotoristaAplicativoActions.obterMotoristaAplicativo(this.id, this.cd_aplicativo)
        .then(res => {
          if (res && res.cd_aplicativo) {
            this.registro = res
          } else {
            this.errorMessage = 'Registro não encontrado.'
          }
          this.showModalLoader--
        })
        .catch(() => {
          this.errorMessage = 'Registro não encontrado.'
          this.showModalLoader--
        })
    } else {
      this.listarAplicativosAtivos()
        .then(() => {
          this.filtrarAplicativosDisponiveis(this.id)
        })
    }
  },
  watch: {
    showModalLoader: function (val) {
      this.$parent.$parent.$data.showModalLoader = val > 0
    }
  },
  methods: {
    voltar () {
      this.$router.push({ path: '/motoristas/' + this.id, query: { ret_url: this.$route.query.ret_url } })
    },
    handleChange (cdAplicativo) {
      this.listarCategorias(cdAplicativo)
      this.listarSegmentos(cdAplicativo)
    },
    listarCategorias (cdAplicativo) {
      this.showModalLoader++

      AplicativoCategoriaActions.listarPorAplictivo(cdAplicativo)
        .then(res => {
          this.categorias = res
          this.showModalLoader--
        })
        .catch(() => {
          this.showModalLoader--
        })
    },
    listarSegmentos (cdAplicativo) {
      this.showModalLoader++

      AplicativoSegmentoActions.listarPorAplictivo(cdAplicativo)
        .then(res => {
          this.segmentos = res
          this.showModalLoader--
        })
        .catch(() => {
          this.showModalLoader--
        })
    },
    listarAplicativosAtivos () {
      this.showModalLoader++

      return AplicativoActions.listarAtivos()
        .then(res => {
          this.appsAtivos = res
          this.showModalLoader--
        })
        .catch(() => {
          this.showModalLoader--
        })
    },
    filtrarAplicativosDisponiveis (id) {
      this.showModalLoader++

      MotoristaAplicativoActions.obterMotoristaAplicativo(id)
        .then(res => {
          const aplicativosJaExistentes = res.map(i => i.cd_aplicativo)

          this.appsAtivosDisponiveis = this.appsAtivos.filter(i => !aplicativosJaExistentes.includes(i.cd_aplicativo))

          if (!this.appsAtivosDisponiveis.length) {
            this.errorMessage = 'Nenhum aplicativo disponível.'
          }

          this.showModalLoader--
        })
        .catch(() => {
          this.showModalLoader--
        })
    },
    validation () {
      this.errors = {}
      this.hasError = false

      if (!this.registro.cd_aplicativo_categoria) {
        this.errors.cd_aplicativo_categoria = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.cd_aplicativo) {
        this.errors.cd_aplicativo = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.tempo_aplicativo) {
        this.errors.tempo_aplicativo = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.viagens_realizadas) {
        this.errors.viagens_realizadas = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.nota_motorista) {
        this.errors.nota_motorista = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.idc_status) {
        this.errors.idc_status = 'Este campo deve ser preenchido.'
        this.hasError = true
      }
    },
    gravar () {
      this.validation()

      if (!this.hasError) {
        this.$parent.$parent.$data.showModalLoader = true

        if (this.id && this.cd_aplicativo) {
          MotoristaAplicativoActions.alterarMotoristaAplicativo({
            id: this.id,
            aplicativo: this.cd_aplicativo,
            cd_aplicativo_categoria: this.registro.cd_aplicativo_categoria,
            cd_aplicativo_segmento: this.registro.cd_aplicativo_segmento,
            tempo_aplicativo: this.registro.tempo_aplicativo,
            viagens_realizadas: this.registro.viagens_realizadas,
            nota_motorista: this.registro.nota_motorista
          })
          .then(() => {
            this.$parent.$parent.$data.showModalLoader = false
            this.$router.push({ path: '/motoristas/' + this.id, query: { ret_url: this.$route.query.ret_url } })
          })
          .catch(() => {
            this.errorMessage = 'Ocorreu um erro ao gravar o registro.'
            this.$parent.$parent.$data.showModalLoader = false
          })
        } else {
          MotoristaAplicativoActions.inserirAplicativo({
            cd_motorista: this.registro.cd_motorista,
            cd_aplicativo: this.registro.cd_aplicativo,
            cd_aplicativo_categoria: this.registro.cd_aplicativo_categoria,
            cd_aplicativo_segmento: this.registro.cd_aplicativo_segmento,
            viagens_realizadas: this.registro.viagens_realizadas,
            tempo_aplicativo: this.registro.tempo_aplicativo,
            nota_motorista: this.registro.nota_motorista,
            idc_status: this.registro.idc_status
          })
          .then(() => {
            this.$parent.$parent.$data.showModalLoader = false
            this.$router.push({ path: '/motoristas/' + this.id, query: { ret_url: this.$route.query.ret_url } })
          })
          .catch(() => {
            this.errorMessage = 'Ocorreu um erro ao gravar o registro.'
            this.$parent.$parent.$data.showModalLoader = false
          })
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/motorista/EditarAplicativo.vue